import React from 'react'
import ConnectionForm from './ConnectionForm'
import * as schema from '../../validation'
import I18n, { useI18nFunction } from '../I18n'
import {
  organizationName,
  organizationNumber,
  country,
  fromDate,
  toDate,
  comment,
  isCompanyRegistered,
  isSupplierInfo,
  isClientInfo,
  ownershipStatus,
  isCompanyListed,
  isCaseRelevant,
  stockCount,
  parentCaseId,
} from './fields'

const IndirectOwnershipForm = (props) => {
  const I18nFunction = useI18nFunction();

  return (
    <ConnectionForm
      {...props}
      heading={<I18n id="connection_form.headings.indirect_ownership" />}
      schema={schema.indirectOwnership(I18nFunction)}
      fields={fields}
    />
  )
}

export const fields = [
  isCompanyRegistered(),
  country(),
  parentCaseId(),
  organizationName(),
  organizationNumber(),
  isSupplierInfo(),
  isClientInfo(),
  isCompanyListed(),
  stockCount(),
  ownershipStatus(),
  fromDate(
    <I18n id="connection_form.labels.ownership_from" />,
    <I18n id="connection_form.help_texts.from_date_ownership" />,
  ),
  toDate(
    <I18n id="connection_form.labels.ownership_to" />,
    <I18n id="connection_form.help_texts.to_date_ownership" />,
  ),
  comment(),
  isCaseRelevant(),
]

export default IndirectOwnershipForm
